import { getContext, setContext } from 'svelte';

const key = Symbol('menuState');

export function createMobileMenuState(initialValue: boolean = false) {
	let menuIsActive = $state(initialValue);
	let activeSubmenuId = $state<number | null>(null);
	let languageSubmenuActive = $state(false);

	return {
		isActive() {
			return menuIsActive;
		},
		toggle() {
			menuIsActive = !menuIsActive;
			if (!menuIsActive) {
				activeSubmenuId = null;
				languageSubmenuActive = false;
			}
			return menuIsActive;
		},
		setActive(value: boolean) {
			menuIsActive = value;
			if (!value) {
				activeSubmenuId = null;
				languageSubmenuActive = false;
			}
		},
		activeSubmenuId() {
			return activeSubmenuId;
		},
		openSubmenu(id: number) {
			activeSubmenuId = id;
			languageSubmenuActive = false;
		},
		isLanguageSubmenuActive() {
			return languageSubmenuActive;
		},
		openLanguageSubmenu() {
			languageSubmenuActive = true;
			activeSubmenuId = null;
		},
		closeSubmenu() {
			activeSubmenuId = null;
			languageSubmenuActive = false;
		}
	};
}

export function setMobileMenuState(menuState: ReturnType<typeof createMobileMenuState>) {
	setContext(key, menuState);
}

export function getMobileMenuState(): ReturnType<typeof createMobileMenuState> {
	return getContext(key);
}
